// Chakra imports
import {Box} from "@chakra-ui/react";
import InvoicesUserTable from "../../../components/tables/InvoicesUserTable";
import React, {useEffect, useState} from "react";
import {getData} from "../../../services/api";

export default function Invoices() {

    const [tableData, setTableData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const columnsData = [
        {
            Header: "OBJEKT",
            accessor: "rental.title",
        },
        {
            Header: "GÜLTIG BIS",
            accessor: "rental.date_valid",
        },
        {
            Header: "STATUS",
            accessor: "status",
        },
        {
            Header: "DOWNLOAD",
            accessor: "url",
        },
    ];

    useEffect(() => {
        // Define an async function to fetch data
        const fetchData = async () => {
            try {
                const result = await getData('/api/invoices');
                setTableData(result.data);
                setLoading(false);
            } catch (error) {
                setError(error.message);
                setLoading(false);
            }
        };

        // Call the async function
        fetchData();
    }, []);

  return (
    <Box pt={"80px"}>
        {loading ? (
            <div>Loading...</div>
        ) : error ? (
            <div>Error: {error}</div>
        ) : tableData ? (
            <InvoicesUserTable columnsData={columnsData} tableData={tableData}/>
        ) : (
            <div>Keine Daten gefunden</div>
        )}
    </Box>
  );
}
